"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _react = _interopRequireDefault(require("react"));

var _Item = _interopRequireDefault(require("./../Item"));

var _Column = _interopRequireDefault(require("./Column"));

var _LastColumn = _interopRequireDefault(require("./LastColumn"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Table(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['header']
  }, /*#__PURE__*/_react["default"].createElement(_Item["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['columns']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['column']
  }, /*#__PURE__*/_react["default"].createElement(_LastColumn["default"], null))));
}

var _default = Table;
exports["default"] = _default;